import {has} from 'lodash';

export class PrePaiement {
    hasPr: boolean = false;
    type: string = '';
    nbr: number = 0;
    public bindingData(data) {
        if (has(data, 'prepaye')) {
            this.hasPr = true;
            this.type = data.prepaye.type;
            this.nbr = data.prepaye.nbr
        }
        return this;
    }

}